import React, { createContext, useContext, useMemo } from 'react';
import Asset3DLibrary from '../loaders/Asset3DLibrary';

export const AssetContext = createContext<Asset3DLibrary>(new Asset3DLibrary());

export default function AssetContextProvider({ children }: JSX.ElementChildrenAttribute): JSX.Element
{
  const assetLibrary = useMemo(() => {
    return new Asset3DLibrary();
  }, []);
  return (
    <AssetContext.Provider
      value={assetLibrary}
    >
      {children}
    </AssetContext.Provider>
  );
}

export const useAssetContext: () => Asset3DLibrary = () => useContext(AssetContext);